import { STATS } from '../constants';
import { instance } from '../../axios';

const getStatsCompanyAction = () => {
  return (dispatch) => {
    dispatch({
      type: STATS.GET_STATS_USER,
    });
    instance
      .get('/stats/company')
      .then((results) => {
        dispatch({
          type: STATS.GET_STATS_USER_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: STATS.GET_STATS_USER_FAILURE,
          payload: error,
        });
      });
  };
};

const getStatsUserAction = (month, year, companyId) => {
  return (dispatch) => {
    dispatch({
      type: STATS.GET_STATS_USER,
    });
    const params = new URLSearchParams();
    if (month) params.append('month', month);
    if (year) params.append('year', year);
    if (companyId) params.append('company_id', companyId);
    const query = params.toString();
    instance
      .get(query ? `/stats/user?${query}` : '/stats/user')
      .then((results) => {
        dispatch({
          type: STATS.GET_STATS_USER_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: STATS.GET_STATS_USER_FAILURE,
          payload: error,
        });
      });
  };
};

const cleanStatsAction = () => {
  return (dispatch) => {
    dispatch({
      type: STATS.CLEAN_STATS,
    });
  };
};

export { getStatsUserAction, cleanStatsAction, getStatsCompanyAction };
